import { Fragment, useContext, useRef } from "react";
import { Box, CircularProgress } from "@mui/material";
import { LanguageContext } from "../../../../context/LanguageContext";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { DeleteNewIcon, ImgPlaceHolder, UploadAttachment } from "../../../../assets/icons/icon";
import { ValidateUploadedFile } from "../../../../utils";
import { useSnackbar } from "../../../../context/SnackbarContext";
import styles from "../styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

function ProfileCard({
  business,
  user,
  imageUrl,
  onDeleteBusiness,
  onEditProfile,
  onDeleteAvatar,
  onUploadAvatar,
  isImageLoading
}) {
  const [I18n] = useContext(LanguageContext);
  const { showSnackbar } = useSnackbar();
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const valid = ValidateUploadedFile({ file, I18n, maxFileSize: 10, sizeType: "MB" });
    if (!valid.valid) {
      showSnackbar({ message: valid.message, severity: "error" });
      e.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      onUploadAvatar?.(reader.result);
      e.target.value = "";
    };
  };

  return (
    <Box className={styles.profileCard}>
      {/* LEFT — avatar + upload */}
      <Box className={styles.leftSection}>
        <Box className={styles.avatarWrapper}>
        
          {isImageLoading  ? 
          <Box className={`d-flex justify-content-center align-items-center h-100 ${styles.avatarLoader}`} >
          <CircularProgress size="30px" />
          </Box>
            :
            imageUrl ? (
            <Box className={styles.profileImage} >
            <img
              src={imageUrl}
              alt="avatar"
              className={styles.avatar}
            />
            </Box>
          ) : (
            <Box className={styles.avatarPlaceholder}>
              <ImgPlaceHolder width="40px" height="40px" />
            </Box>
          )}
          {imageUrl ? (
            <button id="profile_card_edit_btn" className={styles.deleteAvatarBtn} onClick={() => { triggerLogEvent(analytics, "setting_profile_image_delete"); onDeleteAvatar?.(); }}>
              <DeleteNewIcon />
            </button>
          ) : null}
        </Box>

        <Box className={styles.uploadLabel} onClick={() => { triggerLogEvent(analytics, "setting_profile_image_upload"); fileInputRef.current?.click(); }}>
          <UploadAttachment />
          <ParagraphText className="fontSize12 fontWeight400 barclayBlueColor">
            {imageUrl ? I18n.change : I18n.upload}
          </ParagraphText>
        </Box>

        <input
          id="profile_card_image_input"
          ref={fileInputRef}
          type="file"
          accept=".jpeg,.jpg,.png"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </Box>

      {/* RIGHT — all content */}
      <Box className={styles.rightSection}>
        <Box className={styles.businessNameSection}>
          <ParagraphText className="fontSize12 fontWeight400 newLightColor">
            {I18n.business_name}
          </ParagraphText>
          <ParagraphText className="fontSize20 fontWeight500 newFontColor">
            {business?.name || "—"}
          </ParagraphText>
        </Box>

        <Box className={styles.infoColumns}>
          <Box className={styles.infoColumn}>
            <ParagraphText className="fontSize12 fontWeight400 newLightColor">
              {I18n.business_category}
            </ParagraphText>
            <ParagraphText className="fontSize14 fontWeight400 newFontColor">
              {business?.category || "—"}
            </ParagraphText>
          </Box>

          <Box className={styles.infoColumn}>
            <ParagraphText className="fontSize12 fontWeight400 newLightColor">
              {I18n.mobile_number}
            </ParagraphText>
            <ParagraphText className="fontSize14 fontWeight400 newFontColor">
              {user?.phone_number || "—"}
            </ParagraphText>
          </Box>

          <Box className={styles.infoColumn}>
            <ParagraphText className="fontSize12 fontWeight400 newLightColor">
              {I18n.landmark}
            </ParagraphText>
            <ParagraphText className="fontSize14 fontWeight400 newFontColor">
              {business?.landmark || "—"}
            </ParagraphText>
          </Box>
        </Box>

        <Box className={styles.actionButtons}>
          <UBButton
            id="delete_business_btn"
            className="ubDeleteButton fontSize14 fontWeight400 textUppercase"
            title={I18n.delete_business}
            onClick={() => { triggerLogEvent(analytics, "setting_profile_delete_btn"); onDeleteBusiness?.(); }}
          />
          <UBButton
            id="edit_profile_btn"
            className="ubSecondaryButton fontSize14 fontWeight400 textUppercase"
            title={I18n.edit_profile}
            onClick={() => { triggerLogEvent(analytics, "setting_profile_edit_btn"); onEditProfile?.(); }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default ProfileCard;
